var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-2"},[_c('empresa-combo',{attrs:{"selected":_vm.empresaSelecionada,"selecionar":_vm.selectEmpresa}}),(_vm.empresaSelecionada)?_c('div',{staticClass:"mt-3 mb-3"},[_c('h4',[_vm._v("Aplicativos")]),_c('aplicativos',{attrs:{"dados":_vm.empresaSelecionada.configs.apps},on:{"change":_vm.changeApp}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }